import { push } from "react-router-redux"
import { call, put, takeEvery } from "redux-saga/effects"
import uuidV4 from "uuid/v4"
import * as Screens from "../screens"
import { addCase, showScreen } from "./actions"
import { DAMAGE_CASE_START_CASE } from "./constants"

export function startCase(lhoRef) {
  return {
    type: DAMAGE_CASE_START_CASE,
    data: { lhoRef },
  }
}

// worker Saga: will be fired on DAMAGE_CASE_START_CASE actions
export function* doStartCase({ data: { lhoRef } }) {
  const caseId = yield call(uuidV4)
  yield put(addCase(caseId, lhoRef))
  yield put(showScreen(Screens.PICTURES_CAMERA))
  yield put(push(`/case/${caseId}/pictures`))
}

export function* watchStartCase() {
  yield takeEvery(DAMAGE_CASE_START_CASE, doStartCase)
}

// This action has no reducer. It exists solely to wrap other actions in a sequence.



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/startCase.js